// extracted by mini-css-extract-plugin
export default {"card":"cookie_card__fhum-","lable":"cookie_lable__tQzWN"};